import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import MainLayout from "./components/layout/MainLayout";

// Pages
import Login from "./pages/Login";
import EmergencyReset from "./pages/EmergencyReset";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Products from "./pages/Products";
import Categories from "./pages/Categories";
import Stock from "./pages/Stock";
import Customers from "./pages/Customers";
import CustomerSettings from "./pages/CustomerSettings";
import MetaLeads from "./pages/MetaLeads";
import Quotes from "./pages/Quotes";
import Callbacks from "./pages/Callbacks";
import Dealers from "./pages/Dealers";
import DealerGroups from "./pages/DealerGroups";
import Sales from "./pages/Sales";
import Accounting from "./pages/Accounting";
import Finance from "./pages/Finance";
import Reports from "./pages/Reports";
import Packages from "./pages/Packages";
import PackageCategories from "./pages/PackageCategories";
import Employees from "./pages/Employees";
import Attendance from "./pages/Attendance";
import Payroll from "./pages/Payroll";
import Settings from "./pages/Settings";
import QuoteTemplates from "./pages/QuoteTemplates";
import XMLSettings from "./pages/XMLSettings";
import Banks from "./pages/Banks";
import TechnicalService from "./pages/TechnicalService";
import Todos from "./pages/Todos";
import TaskManagement from "./pages/TaskManagement";
import Receivables from "./pages/Receivables";

// Website Pages
import WebsiteHome from "./pages/website/WebsiteHome";
import WebsiteAbout from "./pages/website/WebsiteAbout";
import WebsiteServices from "./pages/website/WebsiteServices";
import WebsiteProjects from "./pages/website/WebsiteProjects";
import WebsiteBlog from "./pages/website/WebsiteBlog";
import WebsiteContact from "./pages/website/WebsiteContact";
import WebsiteLeadPage from "./pages/website/WebsiteLeadPage";

// Website Admin Pages
import WebsiteAdminDashboard from "./pages/website/admin/WebsiteAdminDashboard";
import WebsiteAdminLeads from "./pages/website/admin/WebsiteAdminLeads";
import WebsiteAdminServices from "./pages/website/admin/WebsiteAdminServices";
import WebsiteAdminProjects from "./pages/website/admin/WebsiteAdminProjects";
import WebsiteAdminBlog from "./pages/website/admin/WebsiteAdminBlog";
import WebsiteAdminSettings from "./pages/website/admin/WebsiteAdminSettings";
import WebsiteAdminTestimonials from "./pages/website/admin/WebsiteAdminTestimonials";
import WebAdminLogin from "./pages/website/admin/WebAdminLogin";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* CRM Auth Routes - Ana sayfa CRM Login olacak */}
            <Route path="/" element={<Login />} />
            <Route path="/crm" element={<Login />} />
            <Route path="/crm/login" element={<Login />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/emergency-reset" element={<EmergencyReset />} />
            
            {/* 
            ============================================
            WEB SİTESİ SAYFALARI - GEÇİCİ OLARAK DEVRE DIŞI
            Web sitesi hazır olduğunda bu kısım aktifleştirilecek
            ============================================
            
            <Route path="/hakkimizda" element={<WebsiteAbout />} />
            <Route path="/hizmetler" element={<WebsiteServices />} />
            <Route path="/hizmetler/:slug" element={<WebsiteServices />} />
            <Route path="/projeler" element={<WebsiteProjects />} />
            <Route path="/projeler/:slug" element={<WebsiteProjects />} />
            <Route path="/blog" element={<WebsiteBlog />} />
            <Route path="/blog/:slug" element={<WebsiteBlog />} />
            <Route path="/iletisim" element={<WebsiteContact />} />
            <Route path="/teklif" element={<WebsiteLeadPage />} />
            <Route path="/basvuru" element={<WebsiteLeadPage />} />
            
            Website Admin Routes (Web sitesi aktifleştirildiğinde açılacak)
            <Route path="/web/admin/login" element={<WebAdminLogin />} />
            <Route path="/web/admin" element={<WebsiteAdminDashboard />} />
            <Route path="/web/admin/leads" element={<WebsiteAdminLeads />} />
            <Route path="/web/admin/services" element={<WebsiteAdminServices />} />
            <Route path="/web/admin/services/:id" element={<WebsiteAdminServices />} />
            <Route path="/web/admin/projects" element={<WebsiteAdminProjects />} />
            <Route path="/web/admin/projects/:id" element={<WebsiteAdminProjects />} />
            <Route path="/web/admin/blog" element={<WebsiteAdminBlog />} />
            <Route path="/web/admin/blog/:id" element={<WebsiteAdminBlog />} />
            <Route path="/web/admin/testimonials" element={<WebsiteAdminTestimonials />} />
            <Route path="/web/admin/settings" element={<WebsiteAdminSettings />} />
            ============================================
            */}
            
            {/* CRM Main App Routes */}
            <Route element={<MainLayout />}>
              <Route path="/crm/dashboard" element={<Dashboard />} />
              <Route path="/crm/users" element={<Users />} />
              <Route path="/crm/roles" element={<Roles />} />
              <Route path="/crm/categories" element={<Categories />} />
              <Route path="/crm/products" element={<Products />} />
              <Route path="/crm/stock" element={<Stock />} />
              <Route path="/crm/customers" element={<Customers />} />
              <Route path="/crm/customer-settings" element={<CustomerSettings />} />
              <Route path="/crm/meta-leads" element={<MetaLeads />} />
              <Route path="/crm/quotes" element={<Quotes />} />
              <Route path="/crm/quotes/callbacks" element={<Callbacks />} />
              <Route path="/crm/dealer-groups" element={<DealerGroups />} />
              <Route path="/crm/dealers" element={<Dealers />} />
              <Route path="/crm/sales" element={<Sales />} />
              <Route path="/crm/technical-service" element={<TechnicalService />} />
              <Route path="/crm/banks" element={<Banks />} />
              <Route path="/crm/workspace/todos" element={<Todos />} />
              <Route path="/crm/workspace/tasks" element={<TaskManagement />} />
              <Route path="/crm/accounting" element={<Accounting />} />
              <Route path="/crm/accounting/receivables" element={<Receivables />} />
              <Route path="/crm/finance" element={<Finance />} />
              <Route path="/crm/reports" element={<Reports />} />
              <Route path="/crm/packages" element={<Packages />} />
              <Route path="/crm/package-categories" element={<PackageCategories />} />
              <Route path="/crm/employees" element={<Employees />} />
              <Route path="/crm/attendance" element={<Attendance />} />
              <Route path="/crm/payroll" element={<Payroll />} />
              <Route path="/crm/settings" element={<Settings />} />
              <Route path="/crm/settings/quote-templates" element={<QuoteTemplates />} />
              <Route path="/crm/settings/xml" element={<XMLSettings />} />
              
              {/* Eski URL'ler için yönlendirmeler */}
              <Route path="/dashboard" element={<Navigate to="/crm/dashboard" replace />} />
              <Route path="/users" element={<Navigate to="/crm/users" replace />} />
              <Route path="/roles" element={<Navigate to="/crm/roles" replace />} />
              <Route path="/categories" element={<Navigate to="/crm/categories" replace />} />
              <Route path="/products" element={<Navigate to="/crm/products" replace />} />
              <Route path="/stock" element={<Navigate to="/crm/stock" replace />} />
              <Route path="/customers" element={<Navigate to="/crm/customers" replace />} />
              <Route path="/customer-settings" element={<Navigate to="/crm/customer-settings" replace />} />
              <Route path="/quotes" element={<Navigate to="/crm/quotes" replace />} />
              <Route path="/quotes/callbacks" element={<Navigate to="/crm/quotes/callbacks" replace />} />
              <Route path="/dealer-groups" element={<Navigate to="/crm/dealer-groups" replace />} />
              <Route path="/dealers" element={<Navigate to="/crm/dealers" replace />} />
              <Route path="/sales" element={<Navigate to="/crm/sales" replace />} />
              <Route path="/technical-service" element={<Navigate to="/crm/technical-service" replace />} />
              <Route path="/banks" element={<Navigate to="/crm/banks" replace />} />
              <Route path="/workspace/todos" element={<Navigate to="/crm/workspace/todos" replace />} />
              <Route path="/workspace/tasks" element={<Navigate to="/crm/workspace/tasks" replace />} />
              <Route path="/accounting" element={<Navigate to="/crm/accounting" replace />} />
              <Route path="/accounting/receivables" element={<Navigate to="/crm/accounting/receivables" replace />} />
              <Route path="/finance" element={<Navigate to="/crm/finance" replace />} />
              <Route path="/reports" element={<Navigate to="/crm/reports" replace />} />
              <Route path="/packages" element={<Navigate to="/crm/packages" replace />} />
              <Route path="/package-categories" element={<Navigate to="/crm/package-categories" replace />} />
              <Route path="/employees" element={<Navigate to="/crm/employees" replace />} />
              <Route path="/attendance" element={<Navigate to="/crm/attendance" replace />} />
              <Route path="/payroll" element={<Navigate to="/crm/payroll" replace />} />
              <Route path="/settings" element={<Navigate to="/crm/settings" replace />} />
              <Route path="/settings/quote-templates" element={<Navigate to="/crm/settings/quote-templates" replace />} />
              <Route path="/settings/xml" element={<Navigate to="/crm/settings/xml" replace />} />
            </Route>
            {/* Bilinmeyen URL'ler CRM login'e yönlendirilir */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
